import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Facebook, Instagram, Youtube } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-brand-primary text-white mt-20 md:mt-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="bg-white inline-block rounded-2xl p-3 mb-5 shadow-sm">
              <img
                src="/uploads/logo.png"
                alt="Jawad Ali Shah Imambara Girls Postgraduate College"
                className="h-14 w-auto"
              />
            </div>
            <p className="text-white/80 text-sm leading-relaxed max-w-md mb-6">
              Empowering girls through quality education since 1973 —
              a heritage institution affiliated with DDU Gorakhpur University,
              offering B.A. and M.A. programs in a nurturing environment.
            </p>
            <div className="flex gap-3">
              {[
                { Icon: Facebook, href: "https://www.facebook.com/profile.php?id=61560300569460", label: "Facebook" },
                { Icon: Instagram, href: "#", label: "Instagram" },
                { Icon: Youtube, href: "#", label: "YouTube" },
              ].map(({ Icon, href, label }, i) => (
                <a
                  key={i}
                  href={href}
                  target={href === "#" ? undefined : "_blank"}
                  rel={href === "#" ? undefined : "noreferrer"}
                  data-testid={`social-${i}`}
                  className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-brand-secondary hover:text-brand-primary hover:border-brand-secondary transition-colors"
                  aria-label={label}
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif text-lg text-brand-secondary mb-4">
              Quick Links
            </h4>
            <ul className="grid grid-cols-2 gap-x-5 gap-y-2 text-sm">
              {[
                ["About", "/about"],
                ["Courses", "/courses"],
                ["Faculty", "/faculty"],
                ["Vacancies", "/vacancies"],
                ["Notices", "/notices"],
                ["Downloads", "/resources"],
                ["Support", "/support"],
                ["Testimonials", "/testimonials"],
                ["Admission", "/admission"],
                ["Gallery", "/gallery"],
                ["Contact", "/contact"],
              ].map(([label, to]) => (
                <li key={to}>
                  <Link
                    to={to}
                    data-testid={`footer-link-${label.toLowerCase()}`}
                    className="text-white/80 hover:text-brand-secondary transition-colors"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif text-lg text-brand-secondary mb-4">
              Reach Us
            </h4>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-brand-secondary flex-shrink-0" />
                <span>Mian Bazar,<br />Gorakhpur – 273001 (U.P. – INDIA)</span>
              </li>
              <li className="flex gap-3 items-start">
                <Phone className="w-4 h-4 mt-0.5 text-brand-secondary flex-shrink-0" />
                <span>
                  Main Office: <a href="tel:+915514052322" className="hover:text-brand-secondary">+91-551-4052322</a><br/>
                  <span className="text-white/50 text-xs">10 a.m. – 4 p.m.</span><br/>
                  Principal: <a href="tel:+919839417577" className="hover:text-brand-secondary">+91-98394-17577</a>
                </span>
              </li>
              <li className="flex gap-3 items-center">
                <Mail className="w-4 h-4 text-brand-secondary flex-shrink-0" />
                <a href="mailto:principaljasigpgcollegegkp@gmail.com" className="hover:text-brand-secondary break-all">principaljasigpgcollegegkp@gmail.com</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-white/60">
          <div>© {new Date().getFullYear()} Jawad Ali Shah Imambara Girls Degree College. All rights reserved.</div>
          <div>
            Digitally crafted with care by{" "}
            <a
              href="https://www.saminfratech.com"
              target="_blank"
              rel="noreferrer"
              className="text-brand-secondary hover:text-white transition-colors"
            >
              Saminfratech
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
